// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "content-MMGz";
var _3 = "#575757";
var _4 = "1.5rem";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "link-gH0x";
var _8 = "1rem";
var _9 = "#bebebe";
var _a = "pageNotFoundView-mTqd";
var _b = ".8rem";
var _c = "#000";
export { _1 as "busBlue", _2 as "content", _3 as "darkGrey", _4 as "extraLargeFontSize", _5 as "lightGrey", _6 as "lightblue", _7 as "link", _8 as "mediumFontSize", _9 as "mediumLightGrey", _a as "pageNotFoundView", _b as "smallFontSize", _c as "unusedNodeColor" }
